export type SortFitterByType = 'DATE' | 'RATE' | 'DISTANCE';
